import React, { useEffect } from "react";
import Head from "next/head";
import ESIInclude from "@JohnLewisPartnership/jl-esi-components";
import esiSourceWrapper from "../../constants/esiSourceWrapper";
import analyticsTrigger from "../../utils/analytics/trigger/analyticsTrigger";
import { extractExperiences, useExperience } from "../../context/MonetateContext";

export const metadata = {
  title: `Gift Cards`,
  description: `Give the gift of choice. Shop for gift cards and e-gift cards, easily check your balance, and find answers to all your frequently asked questions.`,
};
function GiftCards() {
  const experiment = useExperience("GH | AB-4434 | Streamline JL giftcard hero section");
  let esiSource = "/content-renderer/customer-services/prices-and-payment/gift-cards1";
  if (experiment) {
    esiSource =
      experiment.parameters.feature === "experiment"
        ? "/content-renderer/customer-services/prices-and-payment/gift-cards1/gift-cards-experiment"
        : "/content-renderer/customer-services/prices-and-payment/gift-cards1/gift-cards-control";
  }
  useEffect(() => {
    // This is a hack because there is a space in analytics event name
    analyticsTrigger("dataStateChange", ":prices-and-payment:gift-cards ", {}, "pageload");
  }, []);
  return (
    <>
      <Head>
        <link rel="preconnect" href="scene7.com" />
        <link rel="dns-prefetch" href="scene7.com" />
        <meta name="robots" content="INDEX, FOLLOW" />
        <link rel="preconnect" href="monetate.net" />
        <link rel="dns-prefetch" href="monetate.net" />
      </Head>
      <ESIInclude src={esiSourceWrapper(esiSource)} id="content" />
    </>
  );
}

GiftCards.metadata = metadata;

export async function getServerSideProps(ctx) {
  const props = {};
  props.experiences = extractExperiences(ctx.req);
  return { props };
}

export default GiftCards;
